import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectSeoTabsLinks } from '../../../common/selectors/seoTabsLinks';
import { SeoTabsLinks } from '../../components/SeoTabsLinks';

export const SeoTabsLinksContainer = () => {
  const tabs = useSelector(selectSeoTabsLinks);

  if (tabs.length === 0) {
    return null;
  }

  return <SeoTabsLinks tabs={tabs} />;
};
